<template>
  <div class="tw-flex tw-items-center tw-justify-between">
    <div class="tw-pr-5" :data-testid="`studio-toggle-label-${label}`">
      <div class="tw-mb-1 tw-flex tw-items-center">
        <div class="tw-block tw-text-xs" v-html="label"></div>
        <slot name="info" />
        <StudioBadge v-if="tag" variation="orange" class="tw-ml-1.5">
          {{ tag }}
        </StudioBadge>
      </div>

      <div v-if="subLabel" class="tw-max-w-xl tw-text-xs tw-text-slate-500" v-html="subLabel" />
    </div>
    <StudioToggle
      :id="id"
      :checked="checked"
      :disabled="disabled"
      :disabledReason="disabledReason"
      @update:checked="$event => $emit('update:checked', $event)"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import StudioBadge from './StudioBadge.vue';
import StudioToggle from './StudioToggle.vue';

export default defineComponent({
  name: 'StudioToggleWithLabel',
  components: {
    StudioBadge,
    StudioToggle
  },
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledReason: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: 'studio-toggle'
    },
    label: {
      type: String,
      required: true
    },
    subLabel: {
      type: String,
      default: ''
    },
    tag: {
      type: String,
      default: ''
    }
  },
  emits: ['update:checked']
});
</script>
